import React from 'react';
import useProfileImage from '../../hooks/useProfileImage';

const FALLBACK_STYLES = {
  light: {
    container: 'bg-indigo-100 dark:bg-indigo-600/30',
    icon: 'text-indigo-500 dark:text-indigo-300',
  },
  solid: {
    container: 'bg-indigo-600',
    icon: 'text-white',
  },
};

export function formatInitials({ firstName, lastName, fullName } = {}) {
  if (firstName || lastName) {
    const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
    return initials || '??';
  }
  if (fullName) {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    if (parts.length === 1 && parts[0].length >= 2) return parts[0].slice(0, 2).toUpperCase();
    if (parts.length === 1) return parts[0][0].toUpperCase();
  }
  return '??';
}

function DefaultUserIcon({ className = 'w-[55%] h-[55%]' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
}

export default function ProfileAvatar({
  type,
  id,
  hasProfileImage = false,
  variant = 'light',
  className = 'w-full h-full object-cover',
  containerClassName = '',
  iconClassName = '',
  refreshKey = 0,
  fetchImage = true,
  lazyImage = false,
}) {
  const blobUrl = useProfileImage(type, id, hasProfileImage, refreshKey, {
    enabled: fetchImage,
    lazy: lazyImage,
  });
  const styles = FALLBACK_STYLES[variant] || FALLBACK_STYLES.light;

  if (blobUrl) {
    return (
      <div className={`w-full h-full overflow-hidden ${containerClassName}`}>
        <img src={blobUrl} alt="" className={className} loading="lazy" decoding="async" />
      </div>
    );
  }

  return (
    <div
      className={`w-full h-full overflow-hidden flex items-center justify-center ${styles.container} ${containerClassName}`}
      aria-hidden
    >
      <DefaultUserIcon className={`w-[55%] h-[55%] ${styles.icon} ${iconClassName}`} />
    </div>
  );
}
